import * as React from 'react';

import { translate as t } from '../../../translations';
import { withOnChangeProperty } from '../../../utils';
import { Tab, Tabs } from '../../ui';
import { FontSettings } from './FontSettings';
import { IconSettings } from './IconSettings';

/**
 * Renders a form that enables editing label settings.
 */
export class LabelSettings extends React.PureComponent {
    constructor(props) {
        super(props);
        withOnChangeProperty(this);
    }

    render() {
        const { value = {}, defaults, state, states, onChangeState } = this.props;

        return (
            <Tabs state={state} states={states} onChangeState={onChangeState}>
                <Tab id="label" label={t('STYLE.LABEL')}>
                    <FontSettings
                        value={value.label}
                        name="label"
                        onChange={this.onChangeProperty}
                        defaults={defaults.label}
                    />
                </Tab>
                <Tab id="icon" label={t('STYLE.ICON')}>
                    <IconSettings
                        value={value.icon}
                        name="icon"
                        onChange={this.onChangeProperty}
                        defaults={defaults.icon}
                    />
                </Tab>
            </Tabs>
        );
    }
}
